import { render, staticRenderFns } from "./smsmessage.vue?vue&type=template&id=1f0f4496&"
import script from "./smsmessage.vue?vue&type=script&lang=ts&"
export * from "./smsmessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "smsmessage.vue"
export default component.exports